// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"65e3f33b","453":"e36c6887","455":"7fc223d0","977":"6ee10707"}[chunkId] + ".chunk.js";
};